import {autoserializeAs, inheritSerialization} from 'cerialize';
import {RsvpAnswer} from './rsvp-answer';

@inheritSerialization(RsvpAnswer)
export class RsvpMultipleChoiceAnswer extends RsvpAnswer {
  public static readonly type = 'RsvpMultipleChoiceAnswer';
  public readonly type = RsvpMultipleChoiceAnswer.type;

  @autoserializeAs('rsvp_question_option_id')
  public rsvpQuestionOptionId: number;
}
